import type { CrmCustomFiltersDescription, CrmIntegrationCustomFilterGroup } from "../types/custom-filter-options";
import type { BaseCrmIntegrationObject } from "../types/object-type";

const selectActiveCrmFilterGroup = (
    description: CrmCustomFiltersDescription | undefined,
): CrmIntegrationCustomFilterGroup | undefined => {
    if (!description) {
        return undefined;
    }

    const groups = description.integrationCustomFilterGroups;

    return groups.find((group) => group.filters.length > 0) ?? groups[0];
};

export const resolveActiveCrmIntegration = (
    description: CrmCustomFiltersDescription | undefined,
): BaseCrmIntegrationObject | undefined => {
    const activeGroup = selectActiveCrmFilterGroup(description);

    return activeGroup
        ? { integrationName: activeGroup.integrationName, objectType: activeGroup.objectType }
        : undefined;
};
